export interface Invoice {
  id: string;
  createdDate: string;
  updatedDate: string;
  referenceInvoiceNumber: string;
  supTyp: string;
  invoiceDate: string;
  dueDate: string;
  invoiceAmount: number;
  invoiceAmountWithAdjustment: number;
  invoiceAmountBase: number;
  LRNumber: string;
  LRDate: null | string;
  lines: InvoiceLine[];
  paidAmount: number;
  taxApplied: number;
  irn: string;
  customerName: string;
  docType: string;
  gstin?: string;
  docNumber: string;
  status: string;
  invoiceStatus: string;
  narration?: string;
  workspaceId: string;
  inviteId: string;
  docs?: InvoiceDocs[];
  info?: string;
  url?: string;
  linkedWorkspacesId: string;
  locationId?: string;
  payments: InvPayment[];
  paymentDate?: string;
  outStandingAmount: number;
  refOrderNumbers: string[];
  erpOrderNmber?: string;
  description?: string;
  dueInDays?: number;
  messageStatus?: any;
}

export interface InvoiceDocs {
  doctype: string;
  filename: string;
  mimetype: string;
  subtype: string;
  url: string;
}

export interface InvoiceLine {
  erpOrderNumber: string;
  refOrderNumber: string;
  trackPONumber: string;
  sku: string;
  invoicedQuantity: number;
  bouncedQuantity: number;
  freeQuantity: null | number;
  listPrice: number;
  listPriceWithTax: number;
  lineTotalWithTax: number;
  SGSTAmount: number;
  CGSTAmount: number;
  IGSTAmount: number;
  CGSTRate: number;
  GSTRate: number;
  SGSTRate: number;
  TCSAmount: number;
  TCSRate: number;
  TDSAmount: number;
  TDSRate: number;
  UTGSTAmount: number;
  UTGSTRate: number;
  IGSTRate: number;
  lineDiscount: number;
  batchId: string;
  name: string;
  skuCode: string;
  PTR: number;
  expiryDate: string;
  PTS: number;
  MRP: number;
  batchCode: string;
  batchExpiryDate: string;
  taxApplied: number;
  orderedDate: string;
  orderedQuantity?: number;
  InvoiceMRP?: number;
  InvoicePTR?: number;
  productTitle?: string;
}

interface InvPayment {
  invoiceId: string;
  id: string;
  amountPaid: number;
  paymenDate: Date;
  amountCleared: number;
  paymentRefCode: string;
  paymentMode: string;
  paymentType: string;
  status: string;
  bankName: string;
  bankAccountNumber: string;
  bankReference: string;
  bankCode: string;
  channel: string;
  cardNumber: string;
  cardNetwork: string;
  cardType: string;
  upiId: string;
  instrumentDate: string;
  instrumentNumber: string;
}
export interface InvoiceDetailsRequest {
  workspaceId: string;
  invoiceId: string;
  customerId?: string;
}

export interface InvoiceListRequest {
  endDate?: string;
  startDate?: string;
  pageNo?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  workspaceId: string;
  inviteId?: string;
  invoiceStatus?: string[];
  searchKey?: string;
  dispatchFilter?: boolean;
  body?: { invoiceIds?: string[]; docNumbers?: string[] };
  filterPending?: boolean;
}

export interface InvoiceList {
  total: number;
  invoices: Invoice[];
  totalInvoices: number;
  startRecord: number;
  endRecord: number;
  statusCode: number;
  responseStatus: string;
  customers: CustomerData[];
}

interface CustomerData {
  customerId: string;
  name: string;
}

export interface InvoiceRequest {
  endDate?: string;
  startDate?: string;
  pageNo?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  workspaceId: string;
  inviteId?: string;
  invoiceStatus?: string[];
  searchKey?: string;
  customerIds?: string[];
  body?: { invoiceIds?: string[]; docNumbers?: string[] };
}

export interface InvoiceParsedDataRequest {
  sellerWorkspaceId?: string;
  body: any;
}
export interface InvoiceParsedDataResponse {
  invoiceNumber?: string;
  invoiceDate?: string;
  invoiceAmount?: string;
  dueDate?: string;
  note?: string;
  totalAmount: string;
  deliveryNote: string;
  motorVehicleNo: string;
  otherReferences: string;
  buyersOrderNo: string;
  dispatchDocNo: string;
  deliveryNoteDate: string;
  dispatchedThrough: string;
  destination: string;
  lrNo: string;
  Pincode?: string;
  termsOfDelivery: string;
  paymentStatus: string;
  transactionDate: string;
  transactionTime: string;
  upiTransactionId: string;
  bankTransactionId: string;
  SenderPhoneNumber: string;
  ShipToPhoneNumber: string;
  SenderGstin: string;
  irn: string;
  eWayBillNumber: string;
  paymentMode: string;
  upiId: string;
  bankReference: string;
  amountPaid: string;
  paymentDate: string;
  paymentTime?: string;
  paymentType?: string;
  paymentRefCode?: string;
  bankName?: string;
  bankAccountNumber?: string;
  narration?: string;
  instrumentNumber?: string;
  cardNumber?: string;
  cardType?: string;
  paymentProvider?: string;
}

export interface DispatchNoteState {
  dispatchId: string;
  awbLrDocketNumber: string;
  dispatchDate: string;
  totalBox: string;
  totalWeight: string;
  transporterName: string;
  vehicleNumber: string;
  driverName: string;
  driverPhoneNumber: string;
  city: string;
  pincode: string;
  fullAddress: string;
  customerMaster: boolean;
  deliveryTerms: string;
  selectedOrder: string[];
  selectedInvoice: string[];
  selectedDocType: string;
  selectedFileType: string;
  uri: string;
  isFileUploading: boolean;
  isDispatchSelected: boolean;
  isFileUploaded: boolean;
}

export const dispatchNoteInitialState: DispatchNoteState = {
  dispatchId: '',
  awbLrDocketNumber: '',
  dispatchDate: '',
  totalBox: '',
  totalWeight: '',
  transporterName: '',
  vehicleNumber: '',
  driverName: '',
  driverPhoneNumber: '',
  city: '',
  pincode: '',
  fullAddress: '',
  customerMaster: false,
  deliveryTerms: '',
  selectedOrder: [],
  selectedInvoice: [],
  selectedDocType: '',
  selectedFileType: '',
  uri: '',
  isFileUploading: false,
  isDispatchSelected: false,
  isFileUploaded: false,
};

export type ChannelMemberRole = 'ADMIN' | 'MEMBER' | 'CUSTOMERADMIN' | null;

export enum IssueTransactionType {
  DISPATCH = 'dispatch',
  ORDER = 'order',
  INVOICE = 'invoice',
  PAYMENT = 'payment',
  UNKNOWN = 'unknown',
}

export enum DispatchNoteEnum {
  INVOICE = 'invoice',
  LORRY_RECEIPT = 'lorry_receipt',
  COURIER_RECEIPT = 'courier_receipt',
  E_WAY_BILL = 'e_way_bill',
  DELIVERY_CHALLAN = 'delivery_challan',
}

export enum IssueRole {
  ASSIGNED = 'assigned',
  WATCHER = 'watcher',
  CREATOR = 'creator',
}

export interface ChannelCustomer {
  name?: string;
  inviteId: string;
  distributorCode?: string;
  companyName?: string;
  stateName?: string;
  cityName?: null;
  phone?: string;
  employeeName?: string;
  team?: CustomerTeam[];
}

export interface CustomerTeam {
  createdDate: string;
  employeeName: string | null;
  id: string;
  inviteType: string;
  invitedUserId: string;
  invitedWorkspaceId: string;
  isActive: number;
  isArchive: number;
  phone: string;
  phone2: string | null;
  role: string;
  senderUserId: string;
  senderWorkspaceId: string;
  status: string;
  updatedDate: string;
  userType: string | null;
}

export interface ChannelTeamMember {
  teamMemberRole?: any;
  inviteId: string;
  employeeCode?: string;
  employeeName?: string;
  cityName?: null | string;
  stateName?: null | string;
  isActive?: boolean;
  mobile?: string;
  role?: 'MEMBER' | 'ADMIN' | 'CUSTOMERADMIN' | any;
  userId?: string;
  phone?: string;
  issueRole?: IssueRole;
  companyName?: string;
}

export interface CompanyTeamMembers {
  cityName: string;
  companyName: string;
  employeeCode: string;
  employeeName: string;
  fulfillmentLocationId: string;
  inviteId: string;
  stateName: string;
  role?: string;
}

export interface ChannelDetailsRequest {
  workspaceId: string;
  channelId?: string;
  sellerWorkspaceId: string;
  customerId?: string;
  channelType?: string;
  random?: number;
}

export interface ItemList {
  sku: string;
  erpOrderNumber?: string;
  Qty?: number;
  Unit?: string;
  UnitPrice?: number;
  lineTotal?: number;
  lineTotalWithTax?: number;
  lineDiscount?: number;
  ptrDiscAmt?: number;
  Discount?: number;
  AssAmt?: number;
  GstRt?: number;
  CgstAmt?: number;
  IgstAmt?: number;
  SgstAmt?: number;
  batchNo?: string;
  expiryDate?: string;
  packSize?: number;
  divisionCode?: string;
  TDSRate?: number;
  TCSRate?: number;
  TDSAmount?: number;
  TCSAmount?: number;
  UTGSTRate?: number;
  UTGSTAmount?: number;
  discountPercent?: number;
  MRP?: number;
  PTR?: number;
  productTitle?: string;
  freeQuantity?: number;
}

export interface ChannelDetails {
  id: string;
  createdAt: string;
  updatedAt: string;
  channelName: string;
  linkedWorkspaceId: string;
  accessType: string;
  profilePic?: string;
  updatedBy: null;
  emojiId: string;
  description: string;
  ownerId?: string | null;
  isDefault?: boolean;
  appId: string;
  channelType: string;
  channelSubType?: string;
  customerId?: string;
  customerName?: string;
  companyName?: string;
  transactionType?: IssueTransactionType;
  channelRole?: string;
  workspaceId: string;
  folderId?: string;
  role?: ChannelMemberRole;
  customers?: ChannelCustomer[];
  teamMembers?: ChannelTeamMember[];
  companyTeamMembers?: CompanyTeamMembers[];
  latestMessage?: string;
  latestMessageTimeToken?: string;
  latestTransactionMessage?: string;
  type: string;
  isActive: boolean;
  latestWaMessageTimeToken?: string;
  status?: boolean;
  sellerWorkspaceId?: string;
  action?: string;
  unreadCount: number;
  isLockedCustomer?: boolean;
  customerInfo?: any;
  customerIsLoading?: boolean;
  totalMessageCount?: number;
  issueStatus?: string;
  phoneNumber?: string;
  threadTags?: any[];
  marketingMessageLimitExhausted?: boolean;
  optedOut?: boolean;
  customerCode?: string;
  lastVisitedTimeToken: string;
}

export interface DispatchNoteParsedDataRequest {
  workspaceId?: string;
  body: any;
}

export interface DispatchNoteParsedDataResponse {
  parsedText: {
    response: {
      extracted_data: Record<string, string>;
    };
  };
  statusCode: number;
  responseStatus: string;
}

export interface InvoiceSearchParameter {
  parameterId: string;
  value: string;
  updateSearchValue?: string | string[];
}

interface CustomerData {
  customerId: string;
  name: string;
}

export interface DispatchListRequest {
  workspaceId: string;
  body?: DispatchListBody;
  dispatchFilter?: boolean;
}

export interface DispatchListBody {
  invoiceId?: string;
  orderId?: number;
  transporterName?: string;
  vehicleNumber?: string;
  driverName?: string;
  driverPhone?: string;
  destinationCity?: string;
  destinationZipCode?: string;
  sortBy?: string;
  sortDirection?: string;
  searchKey?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
  status?: string;
  customerId?: string[];
}

export interface DispatchListResponse {
  dispatchList: DispatchList[];
  customers: CustomerData[];
  totalRecords: number;
  startRecord: number;
  endRecord: number;
  statusCode: number;
  responseStatus: string;
}

export interface DispatchList {
  id: string;
  createdDate: string;
  updatedDate: string;
  dispatchDocNumber: string;
  dispatchDate: string;
  type: string;
  status: string;
  customerName: string;
  numOfBoxes: number;
  totalWeightINKg: number;
  transporterName: string;
  vehicleNumber: string;
  workspaceId: string;
  inviteId: string;
  isArchived: boolean;
  driverName: string;
  driverPhone: string;
  destinationCity: string;
  destinationZipCode: string;
  destinationAddress: string;
  termsOfDelivery: string;
  orderIds: string[];
  docs: Docs;
  invoiceId?: string;
  deliveryDate: string;
}

interface orderDisptach {
  orderId: string;
  refOrderNumber: string;
}

export interface DispatchListDetailsRes {
  id: string;
  createdDate: string;
  updatedDate: string;
  dispatchDocNumber: string;
  dispatchDate: string;
  type: string;
  status: string;
  numOfBoxes: number;
  totalWeightINKg: number;
  transporterName: string;
  vehicleNumber: string;
  workspaceId: string;
  inviteId: string;
  isArchived: boolean;
  driverName: string;
  driverPhone: string;
  destinationCity: string;
  destinationZipCode: string;
  destinationAddress: string;
  termsOfDelivery: string;
  orderIds: string[];
  docs: Docs[];
  orders: orderDisptach[];
  invoiceId: string;
  deliveryDate: string;
  statusCode: number;
  responseStatus: string;
  invoice?: Invoice;
}

export interface Docs {
  url: string;
  subType: DispatchNoteEnum;
}
export enum DispatchNoteStatus {
  All = 'All',
  Draft = 'Draft_Dispatched',
  Dispatched = 'Dispatched',
  Delivered = 'Delivered',
}

export enum InvoiceStatusEnum {
  PAYMENT_PENDING = 'P',
  CANCELLED = 'C',
  PAID = 'PD',
  PARTIALLY_PAID = 'PP',
  ALL_PAYMENTS = '',
  OVER_DUE = 'OD',
  UNPAID = 'UD',
}

export const InvoiceStatusNames = {
  [InvoiceStatusEnum.PAYMENT_PENDING]: 'Pending',
  // [InvoiceStatusEnum.CANCELLED]: 'Cancelled',
  [InvoiceStatusEnum.PAID]: 'Paid',
  [InvoiceStatusEnum.PARTIALLY_PAID]: 'Partially Paid',
  // [InvoiceStatusEnum.OVER_DUE]: 'Over Due',
  // [InvoiceStatusEnum.UNPAID]: 'Unpaid',
};

export interface createDispatchNoteReq {
  workspaceId: string;
  dispatchDocNumber: string;
  dispatchDate: string;
  numOfBoxes?: string;
  totalWeightINKg?: string;
  transporterName?: string;
  vehicleNumber?: string;
  driverName?: string;
  driverPhone?: string;
  destinationCity?: string;
  destinationZipCode?: string;
  destinationAddress?: string;
  termsOfDelivery?: string;
  deliveryDate?: string;
  type?: string;
}

export interface createDispatchNoteResponse {
  dispatchDocNumber: string;
  dispatchDate: string;
  numOfBoxes: string;
  totalWeightINKg: string;
  transporterName: string;
  vehicleNumber: string;
  driverName: string;
  driverPhone: string;
  destinationCity: string;
  destinationZipCode: string;
  destinationAddress: string;
  termsOfDelivery: string;
  orderId: number;
  invoiceId: number;
  deliveryDate: string;
  id: string;
  createdDate: string;
  updatedDate: string;
  statusCode: number;
  responseStatus: string;
}
